<template>
    <BlockUI :blocked="loadingData">
        <Card  dir="rtl" id="SCHEDULE" >
            <template #header>
                <div style="width: 100%;" class="p-p-2 ">
                    <div class="p-m-1 p-pt-3 noScreen">
                        <h1 class="" style="text-align: center">
                           {{ getGradeName() }}
                        </h1>
                    </div>

                    <div class="">


                    </div>
                </div>
            </template>
            <template class="p-p-0" #content>
                <tbody class="p-grid p-p-0">

                <Header add-class="grade" class="p-col-12"/>
                <row-schedule
                        :loading="loadingData"
                        :rowScheduleValue="scheduleGrade && scheduleGrade[lesson.id]"
                        v-for="lesson in lessonTime"
                        :lesson="lesson"
                        :grade="grade"/>
                </tbody>
            </template>
<!--            <Button @click="printDiv"></Button>-->

        </Card>
<!--        </div>-->
    </BlockUI>

</template>

<script>
import Header from "@/views/Schedule/Header";
import RowSchedule from "@/views/Schedule/ScheduleGrade/RowSchedule";
import {getScheduleByGrade} from "@/views/Schedule/Schedule.js";
import {mapState} from "vuex";
import TableBody from "../../../../primevue/datatable/TableBody";
import {getGradeFullName} from "@/utils/parseObj";
export default {
    name: "ScheduleTable",
    props: {
        grade: {
            type: String,
            default: null
        },
    },
    components: {
        TableBody,
        RowSchedule,
        Header
    },
     created() {
       this.initSchedule()
    },
    methods: {
        getGradeName(){
           return  getGradeFullName(this.grade)
        },
        async initSchedule() {
            try {
                if (this.grade){
                    this.loadingData = true
                   this.scheduleGrade = await getScheduleByGrade(this.grade)
                    this.loadingData = false

                }
            } catch (e) {
            }
        }
    },
    watch: {
        grade(newValue, oldValue) {
            this.initSchedule()

        }
    },
    data() {
        return {
            loadingData: false,
            scheduleGrade: null,
        }
    },
    computed: {
        ...mapState(["lessonTime", "subjectLesson"]),
    },
}
</script>

<style scoped>
@media screen
{
    .noPrint{}
    .noScreen{display:none;}
}

@media print
{
    /*@page  {*/
    /*    size: landscape;*/
    /*}*/
    .noPrint{display:none;}
    .noScreen{}
}

>>>.p-card-content{
    padding: 0!important;
}

</style>